/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/

import { dynamicGuardRegistry } from './dynamic-guard.registry';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function DynamicGuardService(guardName: string): // eslint-disable-next-line @typescript-eslint/no-explicit-any
(target: any) => void {
  return (target) => {
    if (dynamicGuardRegistry[guardName]) {
      throw new Error(`Dynamic Guard with name ${guardName} has been already registered, choose different name.`);
    }
    dynamicGuardRegistry[guardName] = target;
  };
}
